import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from "vuedraggable";
import SwitchableInput from "@Shared/components/inputs/switchable-input";
import { v4 as uuidv4 } from "uuid";
import { pick } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "EditCustomDropdownItems",
  components: {
    draggable,
    SwitchableInput
  },
  props: {
    values: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    var _context;
    return {
      modelItems: _mapInstanceProperty(_context = _valuesInstanceProperty(this)).call(_context, (item, index) => _objectSpread(_objectSpread({}, item), {}, {
        editing: false,
        order: index
      })),
      newItem: "",
      nonce: 0
    };
  },
  watch: {
    values() {
      var _context2;
      this.modelItems = _mapInstanceProperty(_context2 = _valuesInstanceProperty(this)).call(_context2, (item, index) => _objectSpread(_objectSpread({}, item), {}, {
        editing: false,
        order: index
      }));
    }
  },
  methods: {
    remove(index) {
      var _context3;
      if (this.readOnly) return;
      _spliceInstanceProperty(_context3 = this.modelItems).call(_context3, index, 1);
      this.modelItems = [...this.modelItems];
      this.handleChange();
    },
    addItem() {
      var _context4;
      const newItem = _trimInstanceProperty(_context4 = this.newItem).call(_context4);
      if (newItem !== "") {
        this.modelItems.push({
          name: newItem,
          id: this.generateId(),
          editing: false,
          order: this.modelItems.length
        });
        this.newItem = "";
        this.handleChange();
      }
    },
    handleChange() {
      var _context5;
      this.$emit("input", _mapInstanceProperty(_context5 = this.modelItems).call(_context5, item => {
        return pick(item, ["id", "name"]);
      }));
      this.nonce++;
    },
    generateId() {
      const newId = uuidv4();
      return this.modelItems.some(item => item.id === newId) ? this.generateId() : newId;
    },
    handleEdit({
      index,
      newName
    }) {
      if (newName === "") return;
      this.modelItems[index].name = newName;
      this.handleChange();
    },
    handleEditing(editing) {
      this.$emit("editing", editing);
    }
  }
});